import React from 'react'
import { BsArrowRepeat } from "react-icons/bs";
import './Loading.css'
export default function Loading() {
  return (
    <BsArrowRepeat className="lg spinning" size={60} />
  )
}
